import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getProfileDetails } from 'modules/settings/api';

export const useQueryProfileDetails = (isSidebarOpen?: boolean) => {
  const {
    data: profileDetailsData,
    isLoading: profileDetailsLoading,
    isError: profileDetailsError,
    refetch: refetchProfileDetails,
    isFetching: isFetchingProfileDetails,
  } = useQuery(QUERY_KEYS.SETTINGS_PROFILE_DETAILS, getProfileDetails, { enabled: isSidebarOpen });

  return {
    profileDetailsData,
    profileDetailsLoading,
    profileDetailsError,
    refetchProfileDetails,
    isFetchingProfileDetails,
  };
};
